import ApiService from '@/services/core/api.service'

const ProvinceService = {
  async get (query) {
    return ApiService.get(`admin/provinces?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/provinces', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/provinces/${payload.id}`, payload)
  }
}

export default ProvinceService
